const functionsCurlyBracesNoPlaceholder = /^\\\{\\\}$/u;
const functionsParenthesesNoPlaceholder = /\(\)/u;

export const functionsDeleteScenarios = [
    {
        isScenarioPresent: value => functionsCurlyBracesNoPlaceholder.test(value) || functionsParenthesesNoPlaceholder.test(value),
        handleScenario: editor => {
            editor.executeCommand('deleteBackward');
            editor.executeCommand('deleteForward');
        },
    },
];

// Handle a paste event for sets with unescaped brackets
const inputStartsWithAndEndsWithBrackets = /^\{.*\}$/u;
const escapeBracketsAroundSelection = {
    isScenarioPresent: value => inputStartsWithAndEndsWithBrackets.test(value),
    handleScenario: editor => {
        const setWithoutBrackets = editor.value.slice(1, -1);

        // Remove the pasted in set
        editor.executeCommand('deleteBackward');

        // Re-add the set, this time with escaped brackets
        editor.executeCommand(['insert', `\\{${setWithoutBrackets}\\}`]);
    },
};

export const functionsInsertScenarios = [escapeBracketsAroundSelection];

/**
 * Get the keybindings for the Functions math live editor.
 * @returns {Array} The Functions keybindings.
 */
export function getFunctionsKeybindings() {
    const keybindings = [];

    keybindings.push(
        { key: '{', command: ['insert', '\\{\\placeholder\\bigr\\}'] },
        { key: '}', command: ['insert', '\\}'] },
        { key: '(', command: ['insert', '(\\placeholder\\bigr)'] },
    );

    return keybindings;
}

/**
 * Get the Functions virtual keyboard layout.
 * @param {Object} commonKeys The common keys used across different virtual keyboard layouts.
 * @param {SymbolicShortAnswerQuestion} symbolicQuestion The symbolic short answer question containing the necessary tool-specific properties.
 * @param {Array} symbolicQuestion.functions_variables The author-provided functions variables used in the question.
 * @returns {Array} The keyboard layout.
 */
export function getFunctionsKeyboardLayout(commonKeys, symbolicQuestion) {
    const { deleteKeyCap, moveLeftKeyCap, moveRightKeyCap, nextStepKeyCap, separator } = commonKeys;
    const { functions_variables } = symbolicQuestion;
    const rows = [];

    const maxLettersSupported = 6;
    const curlybraces = { insert: '\\{\\placeholder\\bigr\\}', latex: '\\{\\placeholder\\bigr\\}' };
    const parentheses = { insert: '(\\placeholder\\bigr)', latex: '(\\placeholder\\bigr)' };

    // NOTE: The below ceil and floor functions are yet to be given full scope by authors, will be used in future work.
    /* eslint-disable no-unused-vars */
    const ceil = { insert: '\\lceil\\placeholder\\bigr\\rceil', latex: '\\lceil\\placeholder\\bigr\\rceil' };
    const floor = { insert: '\\lfloor\\placeholder\\bigr\\rfloor', latex: '\\lfloor\\placeholder\\bigr\\rfloor' };
    /* eslint-enable no-unused-vars */

    let variables = functions_variables.split(',').filter(Boolean);
    if (variables.length < maxLettersSupported) {
        const separators = new Array(maxLettersSupported - variables.length).fill(separator);
        variables = separators.concat(variables);
    }

    const firstRowVariables = variables.slice(0, 3);
    const secondRowVariables = variables.slice(3);
    rows.push(
        ['1', '2', '3', separator].concat(firstRowVariables),
        ['4', '5', '6', separator].concat(secondRowVariables),
        ['7', '8', '9', separator, ',', curlybraces, parentheses],
        [moveLeftKeyCap, '0', moveRightKeyCap, deleteKeyCap, separator, separator, nextStepKeyCap],
    );

    return rows;
}
